import './BreadcrumbContainer.scss';
import clsx from 'clsx';
import React, { memo, PropsWithChildren } from 'react';

type Props = PropsWithChildren & {
  containerWrapperClass?: string;
};

export const BreadcrumbContainer = memo(({ containerWrapperClass, children }: Props) => (
  <div
    className={clsx(
      { 'bp-breadcrumb-container': true },
      containerWrapperClass,
    )}
  >
    {children}
  </div>
));
